var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35537 4.40682C3.09342 5.85729 4.2825 7.04637 5.73297 7.78441L6.86054 6.65684C7.00405 6.51333 7.20394 6.47233 7.38332 6.52871C7.95736 6.71835 8.5724 6.82085 9.21307 6.82085C9.349 6.82085 9.47937 6.87485 9.57548 6.97097C9.6716 7.06709 9.7256 7.19745 9.7256 7.33339V9.12725C9.7256 9.26319 9.6716 9.39355 9.57548 9.48967C9.47937 9.58579 9.349 9.63979 9.21307 9.63979C6.90222 9.63979 4.68602 8.7218 3.052 7.08779C1.41798 5.45377 0.5 3.23757 0.5 0.926718C0.5 0.790786 0.553999 0.660421 0.650118 0.564302C0.746236 0.468183 0.876601 0.414185 1.01253 0.414185H2.8064C2.94233 0.414185 3.0727 0.468183 3.16882 0.564302C3.26493 0.660421 3.31893 0.790786 3.31893 0.926718C3.31893 1.56738 3.42144 2.18242 3.61108 2.75646C3.66746 2.93585 3.62645 3.13574 3.48294 3.27925L2.35537 4.40682Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.bb790d302c50e2ec848337fc051ac653.svg";
export { ForwardRef as ReactComponent };